import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseStepViewComponent } from '../../../base-step-view.class';
import { DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { DatasetService } from 'app/main/components/dataset/services/dataset.service';
import { AppService } from 'app/services/app.service';
import { MatDialog } from '@angular/material/dialog';
import { GenerateActualTripDialogComponent } from 'app/main/components/dataset/dialogs/generate-actual-trip-dialog/dialog.component';
import { DatasetListComponent } from 'app/main/components/dataset/base-actions/list/dataset-list.component';
import moment from 'moment';

@Component({
    selector: 'trip-package-step-4',
    templateUrl: './step.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TripPackageStep4Component extends BaseStepViewComponent implements OnInit{
	
	formErrors: any;
	@ViewChild('tripList', { static: false }) tripList: DatasetListComponent;
	public todayFilter = JSON.stringify(['>=', moment.utc().startOf('day')]);

	constructor(
		public appService: AppService,
		public datasetRS: DatasetRecordService,
		public datasetACS: DatasetActionContainerService,
		protected datasetNavigatorService: DatasetNavigatorService,
		public datasetService: DatasetService,
		private dialog: MatDialog
	){
		super(datasetACS, datasetNavigatorService);
	}

	ngOnInit(): void{
		
		
	}

	generate(): void{
		this.dialog.open(GenerateActualTripDialogComponent, {
			data: {
				trip_package: this.datasetRS.record.value,
				datasetACS: this.datasetACS,
				postData: {
					trip_package_id: this.datasetRS.recordId
				}
			}
		}).afterClosed().subscribe(result => {
			if(result){
				this.tripList.reload();
			}
		});
	}
}
